import { IClassConstructor, layout } from 'yandex-maps';
import { Store } from 'features/stores/types';

function createPlacemark(
  regionId: string,
  store: Store,
  dataQa: string,
  iconContentLayout: IClassConstructor<layout.templateBased.Base> | null,
  balloonLayout: IClassConstructor<layout.templateBased.Base> | null,
  zIndexActive?: number,
  zIndex?: number,
) {
  const { lat, long, name } = store;
  const {
    ymaps: { Placemark },
  } = window;

  return new Placemark(
    [Number(lat), Number(long)],
    {
      balloonContent: name,
      closeButton: false,
      dataQa: `${dataQa}-${regionId}-${name}`,
      regionId,
    },
    {
      zIndex,
      zIndexActive,
      balloonLayout: balloonLayout || '',
      iconContentLayout: iconContentLayout || '',
      balloonShadow: false,
      iconLayout: 'default#imageWithContent',
      iconOffset: [0, 0],
      iconImageOffset: [0, 0],
      hideIconOnBalloonOpen: false,
    },
  );
}

export { createPlacemark };
